/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

function RouteWrapper({ isPrivate, component: Component, ...rest }) {
  const authenticated = sessionStorage.getItem('@auth/token');

  if (!authenticated && isPrivate) return <Redirect to="/login" />;
  if (authenticated && !isPrivate) return <Redirect to="/" />;

  return <Route {...rest} render={(props) => <Component {...props} />} />;
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};

export default RouteWrapper;
